<template>
  <a href="#" class="QR" ref="main" @click.prevent="generateQR">
    <span>
      <i class="fa fa-qrcode" style="font-size:13px;"></i>
    </span>
    <canvas v-show="qrOpened" id="qr-code"></canvas>
  </a>
</template>

<script>
import QRious from 'qrious';

export default {
  props: {},
  data() {
    return {
      qrOpened: false
    }
  },
  computed: {},
  mounted() {
    console.log('qr loaded');
    const $vueMaterialQr = $('.vue-material-qr');
    if ($vueMaterialQr.length) {
      const main = this.$refs.main
      $(main).css("display", "block");
      $vueMaterialQr
        .css("display", "block")
        .append(main);
    }
  },
  watch: {},
  methods: {
    generateQR() {
      this.qrOpened = !this.qrOpened;
      new QRious({
        element: document.getElementById('qr-code'),
        value: window.location.href,
        size: 200
      });
    }
  },
  components: {}
}
</script>

<style lang="scss" scoped>
#qr-code {
  position: absolute;
  left: -50%;
  margin-top: 40px;
  z-index: 1;
}

.QR {
  position: relative;
  display: none;

  a {
    color: white;
  }
}
</style>
